'use client';

import React, { useEffect } from 'react';
// Side-effect import: initializes the i18next instance before children render.
import i18n, { defaultLanguage } from '@/i18n';

/**
 * Client boundary that guarantees i18next is initialized before the component
 * tree renders. The active language lives in i18next (persisted to the
 * NEXT_LOCALE cookie); components read and change it via useTranslation().
 */
export function LanguageProvider({ children }: { children: React.ReactNode }) {
  // Keep the document language in sync for screen readers and native font
  // selection behavior.
  useEffect(() => {
    const syncHtmlLang = (lng: string) => {
      document.documentElement.lang = lng;
    };
    syncHtmlLang(i18n.language || defaultLanguage);
    i18n.on('languageChanged', syncHtmlLang);
    return () => {
      i18n.off('languageChanged', syncHtmlLang);
    };
  }, []);

  return <>{children}</>;
}
